import React from "react";
import { IPSFacility, getFacilityLink } from "../../../models/peer-support";
import { UIActions } from "../Actions";

export type FacilityActionsProps = {
	facility: IPSFacility;
	onEditFacility: (data, id: string) => Promise<any>;
	onDeleteFacility: (data) => Promise<any>;
	omitLink?: boolean;
};

export const FacilityActions: React.FC<FacilityActionsProps> = (props: FacilityActionsProps) => {
	const facility: IPSFacility = props.facility;
	return (
		<UIActions
			itemName={facility.name}
			data={facility}
			// onDelete={(data) => this.deleteFacility(data)}
			onDelete={(data) => props.onDeleteFacility(data)}
			editEntityProps={{
				mode: "Edit",
				entity: "facility",
				data: facility,
				// onSubmit: (data) => this.props.editFacility(data, facility.id),
				onSubmit: (data) => props.onEditFacility(data, facility.id),
			}}
			detailUrl={props.omitLink ? undefined : getFacilityLink(facility)}
		/>
	);
};
